import { FC } from 'react';
import { Props } from './types';
import { Root } from './style';

const Text: FC<Props & { children?: any }> = ({
  size,
  weight,
  align,
  truncate,
  underline,
  uppercase,
  palette,
  children,
}) => (
  <Root
    size={size}
    weight={weight}
    align={align}
    truncate={truncate}
    underline={underline}
    uppercase={uppercase}
    palette={palette}
  >
    {children}
  </Root>
);

export default Text;
